import { PARITY_OFFER_MODES, ParityOffer, ParityOfferMode } from 'constants/payloads/parityOffer';

const PARITY_OFFER_DEBUG_APP_STAGES = ['development', 'staging', 'beta'];

/**
 * The campaign mode, inlined at build time on both the client and the edge route. Reading it
 * without a network round-trip is what makes the ParityDeals rollback reliable: if the edge route
 * is the unhealthy subsystem, a fetch-gated rollback would never engage — which is precisely when
 * it is needed. Unknown values fail to `custom` so a typo cannot silently kill the campaign.
 */
export const getParityOfferMode = (mode = process.env.PARITY_OFFER_MODE): ParityOfferMode =>
  PARITY_OFFER_MODES.includes(mode as ParityOfferMode) ? (mode as ParityOfferMode) : 'custom';

export const isParityOfferDebugEnvironment = (appStage = process.env.APP_STAGE): boolean =>
  Boolean(appStage && PARITY_OFFER_DEBUG_APP_STAGES.includes(appStage));

export interface ParityOfferCopy {
  /** Short pill — the one word a one-time sale can never claim. */
  badge: string;
  headline: string;
  detail: string;
  cta: string;
}

/**
 * One source of truth for regional-offer wording so the top bar and the pricing card cannot
 * drift. "Forever" appears exactly once, as the badge, because the whole pitch is that this
 * beats any sale we run: our sales are one-time discounts, this one never expires.
 */
export const getParityOfferCopy = (offer: ParityOffer): ParityOfferCopy => ({
  badge: 'Forever',
  headline: `${offer.percentOff}% off in ${offer.countryName}`,
  detail: 'Every plan, every renewal. Not just your first month.',
  cta: 'See plans',
});
